export const USER_FETCH_REQUESTED = 'USER_FETCH_REQUESTED'
export const USER_FETCH_SUCCEEDED = 'USER_FETCH_SUCCEEDED'
export const USER_FETCH_FAILED = 'USER_FETCH_FAILED'

export const USER_ACCESS_CHECK_SUCCEEDED = 'USER_ACCESS_CHECK_SUCCEEDED'
export const USER_ACCESS_CHECK_FAILED = 'USER_ACCESS_CHECK_FAILED'

export const USER_RESOURCES_FETCH_REQUESTED = 'USER_RESOURCES_FETCH_REQUESTED'
export const USER_RESOURCES_FETCH_SUCCEEDED = 'USER_RESOURCES_FETCH_SUCCEEDED'
export const USER_RESOURCES_FETCH_FAILED = 'USER_RESOURCES_FETCH_FAILED'

export const RESOURCE_EMBED_CONFIG_FETCH_REQUESTED =
  'RESOURCE_EMBED_CONFIG_FETCH_REQUESTED'
export const RESOURCE_EMBED_CONFIG_FETCH_SUCCEEDED =
  'RESOURCE_EMBED_CONFIG_FETCH_SUCCEEDED'
export const RESOURCE_EMBED_CONFIG_FETCH_FAILED =
  'RESOURCE_EMBED_CONFIG_FETCH_FAILED'

export const SHOW_LOADER = 'SHOW_LOADER'
export const HIDE_LOADER = 'HIDE_LOADER'
